import { render, staticRenderFns } from "./yanfa.vue?vue&type=template&id=49948cb1&scoped=true&"
import script from "./yanfa.vue?vue&type=script&lang=js&"
export * from "./yanfa.vue?vue&type=script&lang=js&"
import style0 from "./yanfa.vue?vue&type=style&index=0&lang=css&"
import style1 from "./yanfa.vue?vue&type=style&index=1&id=49948cb1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49948cb1",
  null
  
)

export default component.exports